import { Typography } from "@mui/material";

export type LabelProps = {
  label?: string;
};

const Label = ({ label }: LabelProps) => {
  if (!label) return null;

  return (
    <Typography
      component="label"
      variant="body2"
      sx={{
        display: "block",
        mb: 0.75,
        fontWeight: 600,
        color: "text.secondary",
      }}
    >
      {label}
    </Typography>
  );
};

export default Label;
